var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"purchases"}},[_c('h3',[_vm._v("Purchases")]),_vm._v(" "),_c('paged-purchases',{attrs:{"resourceUrl":this.apiUrl('/users/' + _vm.userId + '/purchases'),"formdata":_vm.formdata}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e308213e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPurchases.vue
// module id = 1286
// module chunks = 1